import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import InputLabel from "@mui/material/InputLabel";

function AutoCompleteComponent({
  options = [],
  value = null,
  onChange = () => {},

  valueKey = "_id",
  labelKey = "name",
  disabled = false,
  loading = false,
  sx = {},
  width,
  //PROPSESTETICOS
  label,
  fontFamily,
  fontWeight,
  colorLabel,
  textColor,
  fontSizeInput,
  fontSize,
  borderColor,
  backgroundColor = "transparent",
  onOpen,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const selectedOption =
    options.find((item) => item[valueKey] === value) || null;

  const placeholderText = isFocused
    ? ""
    : label
    ? `Buscar ${label.toLowerCase()}...`
    : "Buscar...";

  return (
    <Stack>
      <InputLabel
        sx={{
          display: "block",
          marginBottom: "8px",
          color: colorLabel || "#6c6e71",
          fontWeight: fontWeight || 600,
          fontFamily: fontFamily || "Raleway, sans-serif",
          fontSize: fontSizeInput || "14px",
        }}
      >
        {label}
      </InputLabel>

      <Autocomplete
        options={options}
        value={selectedOption}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholderText}
            onFocus={(e) => {
              setIsFocused(true);
              if (
                e.target.value === "Buscar agente..." ||
                e.target.value === "Selecciona un agente" ||
                e.target.value === "Buscar ajustador..." ||
                e.target.value === "Selecciona una opción" ||
                selectedOption?.[valueKey] === "00001"
              ) {
                e.target.value = "";
                const event = new Event("input", { bubbles: true });
                e.target.dispatchEvent(event);
              }
            }}
            onBlur={() => setIsFocused(false)}
          />
        )}
        sx={{
          width: width || "100%",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          },
          "& .MuiOutlinedInput-root": {
            backgroundColor: backgroundColor,
            padding: "0px 14px",
            minHeight: "32px",
            borderRadius: "5px",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
            },
          },
          "& .MuiInputBase-input": {
            color: textColor || "gray",
            fontSize: fontSize || "14px",
            fontFamily: "Raleway, sans-serif",
            paddingTop: "6px !important",
            paddingBottom: "4px !important",
          },
          ...sx,
        }}
        disabled={disabled}
        loading={loading}
        onOpen={onOpen}
        filterOptions={(options, { inputValue }) =>
          options.filter((option) =>
            option[labelKey]?.toLowerCase().includes(inputValue.toLowerCase()),
          )
        }
        onChange={(event, newValue) => {
          onChange(newValue ? newValue[valueKey] : "");
        }}
        getOptionLabel={(option) => option?.[labelKey] || ""}
        isOptionEqualToValue={(option, value) =>
          option[valueKey] === value[valueKey]
        }
        renderOption={(props, option) => (
          <li
            {...props}
            key={option[valueKey]}
            style={{ fontFamily: "Raleway, sans-serif", fontSize: "14px" }}
          >
            {option[labelKey]}
          </li>
        )}
      />
    </Stack>
  );
}

export default AutoCompleteComponent;
